import type { IntegrationBlock, IntegrationsBlocksSet } from '@gitbook/api-client';

/**
 * Lookup a block using a filter.
 */
export function lookupIntegrationBlockInSet(
    set: IntegrationsBlocksSet,
    filter: (input: { integrationKey: string; block: IntegrationBlock }) => boolean
): undefined | { integrationKey: string; block: IntegrationBlock } {
    for (const integrationKey of Object.keys(set)) {
        for (const block of set[integrationKey]) {
            const entry = { integrationKey, block };
            if (filter(entry)) {
                return entry;
            }
        }
    }
    return undefined;
}
